import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { AuthComponent } from './pages/auth/auth.component';
import { AccountComponent } from './pages/account/account.component';
import { PatientsComponent } from './pages/patients/patients.component';
import { inject } from '@angular/core';
import { AuthService } from './services/auth.service';
import { PatientNewComponent } from './pages/patients/patient-new/patient-new.component';
import { ReportComponent } from './pages/reports/report/report.component';
import { SelectAssessmentComponent } from './assessments/select-assessment/select-assessment.component';
import { NhptComponent } from './assessments/nhpt/nhpt.component';
import { AsecsComponent } from './assessments/asecs/asecs.component';
import { BbtComponent } from './assessments/bbt/bbt.component';
import { AratComponent } from './assessments/arat/arat.component';
import { TestPageComponent } from './pages/test-page/test-page.component';
import { AssessmentsComponent } from './pages/reports/assessments/assessments.component';
import { RegisterComponent } from './pages/auth/register/register.component';
import { ChartBaseComponent } from './components/chart-base/chart-base.component';
import { GraphComponent } from './pages/reports/graph/graph.component';
import { BbsComponent } from './assessments/bbs/bbs.component';
import { TsComponent } from './assessments/ts/ts.component';
import { TugComponent } from './assessments/tug/tug.component';
import { FrComponent } from './assessments/fr/fr.component';
import { Mwt6Component } from './assessments/mwt6/mwt6.component';
import { EditUserComponent } from './pages/edit-user/edit-user.component';
import { EditAssessmentListComponent } from './assessments/edit-assessment-list/edit-assessment-list.component';
import { CustomAssessmentComponent } from './assessments/custom-assessment/custom-assessment.component';
import { PasswordResetComponent } from './pages/auth/password-reset/password-reset.component';
import { FgaComponent } from './assessments/fga/fga.component';
import { AssessmentContainerComponent } from './assessment-kit5';

// Helper to simplify canActivate guard
const authGuard = [
  (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
    inject(AuthService).isAuthenticatedOrRedirect(next, state),
];

export const routes: Routes = [
  { path: 'auth', component: AuthComponent },
  { path: 'resetpassword', component: PasswordResetComponent },
  { path: 'registerGeheim', component: RegisterComponent },
  { path: 'account', component: AccountComponent, canActivate: authGuard },
  { path: 'editUser', component: EditUserComponent, canActivate: authGuard },
  { path: 'chart', component: ChartBaseComponent },
  { path: 'test', component: TestPageComponent, canActivate: authGuard },
  { path: 'patients', component: PatientsComponent, canActivate: authGuard },
  { path: 'patients/new', component: PatientNewComponent, canActivate: authGuard },
  {
    path: 'patients/id/:patientId',
    canActivate: authGuard,
    children: [
      { path: '', component: PatientNewComponent },
      { path: 'reports/graph', component: GraphComponent },
      { path: 'reports/report', component: ReportComponent },
      { path: 'reports/assessments', component: AssessmentsComponent },
      { path: 'assessments/new', component: SelectAssessmentComponent },
      { path: 'assessments/edit', component: EditAssessmentListComponent },
      { path: 'assessments/kit', component: AssessmentContainerComponent },
      { path: 'assessments/kit/:assessmentId', component: AssessmentContainerComponent },
      { path: 'assessments/custom', component: CustomAssessmentComponent },
      { path: 'assessments/custom/:assessmentId', component: CustomAssessmentComponent },
      { path: 'assessments/asecs', component: AsecsComponent },
      { path: 'assessments/arat', component: AratComponent },
      { path: 'assessments/arat/:assessmentId', component: AratComponent },
      { path: 'assessments/bbt', component: BbtComponent },
      { path: 'assessments/bbt/:assessmentId', component: BbtComponent },
      { path: 'assessments/nhpt', component: NhptComponent },
      { path: 'assessments/nhpt/:assessmentId', component: NhptComponent },
      { path: 'assessments/bbs', component: BbsComponent },
      { path: 'assessments/bbs/:assessmentId', component: BbsComponent },
      { path: 'assessments/ts', component: TsComponent },
      { path: 'assessments/ts/:assessmentId', component: TsComponent },
      { path: 'assessments/tug', component: TugComponent },
      { path: 'assessments/tug/:assessmentId', component: TugComponent },
      { path: 'assessments/fga', component: FgaComponent },
      { path: 'assessments/fga/:assessmentId', component: FgaComponent },
      { path: 'assessments/fr', component: FrComponent },
      { path: 'assessments/fr/:assessmentId', component: FrComponent },
      { path: 'assessments/mwt6', component: Mwt6Component },
      { path: 'assessments/mwt6/:assessmentId', component: Mwt6Component },
    ],
  },
  { path: '', redirectTo: '/auth', pathMatch: 'full' },
];
